module.exports = __webpack_public_path__ + "static/media/maxar_image.214f1c05.png";